import moment from 'moment-timezone';
import { getTimeZone } from '../services/timeService';
import { uniq } from 'lodash';

export default function useTimezoneOptions(includeLocaleTimeZone?: boolean) {
  const localeTimezone = getTimeZone();
  const USTimezones = moment.tz
    .names()
    .filter((timezone) => timezone.includes('US/'));
  const options = localeTimezone?.includes('America')
    ? USTimezones
    : [...USTimezones, ...['Asia/Gaza', 'Asia/Hebron', 'Asia/Jerusalem']];

    return uniq([includeLocaleTimeZone ? localeTimezone : '', ...options])
    .filter((name) => name)
    .map((name) => ({
      label: `${name} (${moment().tz(name).format('z')})`,
      value: name,
    }));
}
